import actionTypes from '../constants/action-types';

const fetchPublishedSite = () => ({
  type: actionTypes.FETCH_PUBLISHED_SITE,
});

export default fetchPublishedSite;
